import * as React from "react";
const SvgFiRrBank = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bank_svg__a)">
      <path
        fill="#062147"
        d="M24 23a1 1 0 0 1-1 1H1a1 1 0 0 1 0-2h22a1 1 0 0 1 1 1M.29 8.552a2.44 2.44 0 0 1 .154-2.566c.427-.627 1-1.142 1.668-1.5l7.5-3.904a5.17 5.17 0 0 1 4.775 0l7.5 3.907c.668.358 1.24.873 1.668 1.5a2.44 2.44 0 0 1 .153 2.566A2.71 2.71 0 0 1 21.292 10H21v8h1a1 1 0 1 1 0 2H2a1 1 0 0 1 0-2h1v-8h-.292A2.71 2.71 0 0 1 .29 8.552M5 18h3v-8H5zm5-8v8h4v-8zm9 0h-3v8h3zM2.063 7.625A.72.72 0 0 0 2.708 8h18.584a.72.72 0 0 0 .645-.375.45.45 0 0 0-.024-.5 2.7 2.7 0 0 0-.95-.864l-7.5-3.907a3.18 3.18 0 0 0-2.925 0l-7.5 3.907a2.7 2.7 0 0 0-.95.865.45.45 0 0 0-.025.499"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bank_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBank;
